import * as React from "react";
const FBSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={50}
    height={50}
    fill="none"
    {...props}
  >
    <rect width={49} height={49} x={0.5} y={0.5} stroke="#FAFBFC" rx={24.5} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M31 17H19c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h6v-5.5h-2V25h2v-2a3 3 0 0 1 3-3h2v2.5h-1c-.552 0-1-.052-1 .5v2h2.5l-1 2.5H28V33h3c1.103 0 2-.897 2-2V19c0-1.103-.897-2-2-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default FBSVG;
